import { useSelector } from 'react-redux';

import { selectShopMetaDescription } from 'src/redux/content/selectors/selectShopMetaDescription';
import { selectTaxonomyCanonical } from 'src/redux/content/selectors/selectTaxonomyCanonical';
import { selectTaxonomyRobotsContent } from 'src/redux/content/selectors/selectTaxonomyRobotsContent';

export interface TaxonomySeoTags {
  /** Absolute `<link rel="canonical">` href (always present). */
  canonical: string;
  /** `<meta name="description">` content, or `undefined` when no tag should be emitted. */
  description: string | undefined;
  /** `<meta name="robots">` content, or `null` when no tag should be emitted. */
  robots: string | null;
}

/**
 * The taxonomy PLP's page-level SEO tags (canonical, description, meta robots), derived from
 * the same neighbourhood map and `indexable` flag (gated by the shared
 * "opened-up" decision) that drive the header content and facet-link
 * followability. Computed in a hook alongside {@link useTaxonomyHeaderContent}
 * so both tags stay correct across client-side neighbourhood transitions.
 */
export const useTaxonomySeoTags = (): TaxonomySeoTags => {
  const canonical = useSelector(selectTaxonomyCanonical);
  const description = useSelector(selectShopMetaDescription);
  const robots = useSelector(selectTaxonomyRobotsContent);

  return { canonical, description, robots };
};
